import { useMutation } from '@tanstack/react-query';

import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';
import { useAuthContext } from '../context';

/** Applies the refreshed profile for candidates so `profileComplete` flips client-side and unlocks /portal. */
export const useCompleteLearnerOnboarding = () => {
  const { methods } = useAuthContext();

  return useMutation({
    mutationFn: async (values: Types.IApi.CompleteLearnerOnboarding.Request) => {
      const { data } = await Api.CompleteLearnerOnboarding(values);
      return data;
    },
    onSuccess: (data) => {
      methods.setUser(Mappers.User(data.user));

      const orgs = (data.organizations || []).map((o: any) => ({
        ...Mappers.Organization(o),
        role: o.role,
      }));
      methods.setOrganizations(orgs);

      methods.setOrganization(data.organization ? Mappers.Organization(data.organization) : null);
      methods.setRole(data.role);

      methods.setPermissions([]);
      methods.setEntitlements(null);
    },
  });
};
